<template src="./templates/correct.html" />

<script type="text/ecmascript-6">
import FouAccordion from 'components/tools/fou-accordion/'
import FouAccordionItem from 'components/tools/fou-accordion/item'
import FouContainer from 'src/components/tools/fou-container/'
import SubmissionLoading from 'src/pages/submissions/components/loading/'
import { SubmissionObject,  errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import showChannnelsMixin from 'src/pages/submissions/script/channel.mixins'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import FouGroup from 'src/components/layout/fou-group/'
import FouGrid from 'src/components/layout/fou-grid/'
import Upload from 'src/pages/submissions/components/upload/'
import Prices from 'src/pages/submissions/components/prices/'
import Descriptions from 'src/pages/submissions/components/descriptions/'
import Graphics from 'src/pages/submissions/components/graphics/'
import MessageHistory from 'src/pages/submissions/components/message-history/'
import dateScheduler from 'src/pages/submissions/components/confirmation/dateScheduler'
import Methods from 'src/pages/submissions/script/index.methods'
import Misc from 'src/utils/helper/misc'
import Channels from 'src/pages/submissions/components/channels/'
import { mapGetters } from 'vuex'
import FouTextArea from 'src/components/form/text-area/index.vue'
import { useForm } from 'vee-validate'
import { isEmpty } from 'lodash'

export default {
  name: 'SubmissionsCorrect',

  components: {
    FouAccordion,
    FouAccordionItem,
    FouContainer,
    FouGroup,
    ...FouGrid,
    Upload,
    Prices,
    Descriptions,
    Graphics,
    SubmissionLoading,
    MessageHistory,
    dateScheduler,
    Channels,
    FouTextArea
  },
  mixins: [showChannnelsMixin],

  setup() {
    const { errors } = useForm()
    return {
      errors
    }
  },

  data() {
    return {
      ...SubmissionObject,
      description: '',
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      validationErrors: false,
      uniqueStyleErrors: []
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('auth', ['hasRole']),
  },

  created() {
    SubmissionObject.readyComplete = false
    this.setSubscription()
    this
      .addReadyState()
    this
      .startSubmission()
      .then(() => {
        this.setDefaultUser()
        this.updateSubmissionSteps()
        this.ready.state = 'set'
      })
    this.$events?.$on('check:style unique name', this.checkUniqueStyle)
  },
  beforeUnmount() {
    this.$events.$off('check:style unique name')
  },

  methods: {
    ...SubmissionMethods,
    ...Methods,
    ...Misc,
    isEmpty,
    routeToHome() {
      this.$router.replace({ name: 'home' })
    },
    async handleSubmitCorrection() {
      this.checkUniqueStyle()
      if (isEmpty(this.uniqueStyleErrors) && isEmpty(this.validationErrors)) {
        this.$events.$emit('checkForReleaseDate')
        this.submission.description = this.description || ''
        this.submission.status = 'in_review'
        this.setDefaultUser()
        const response = await this.$store.dispatch('submissions/update', this.submission)
        if (response) {
          this.navigateToSubmissionSuccess()
        } else {
          this.submission.status = 'in_correction'
        }
      }
    },
    submitCorrection() {
      this.$events.$emit('trigger:validate')
      /**
       * Look at for the best alternative
       */
      setTimeout(() => {
        this.validationErrors = isEmpty(submissionErrors.value)
        if (this.validationErrors) {
          this.handleSubmitCorrection()
        }
      }, 200)
    }
  }
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>
